import PropTypes from 'prop-types'

const ResponseIcon = ({ className }: { className: string }) => (
  <svg width="17px" height="17px" viewBox="0 0 17 17" version="1.1" className={className}>
    <title>{'Builder/ Operation/ ResponseIcon'}</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(2.000000, 2.000000)" stroke="#1A56DB" strokeWidth="2">
        <path
          d="M0,3.638889 L8.7333336,3.638889 C11.1451892,3.638889 13.1000004,5.59370017 13.1000004,8.0055558 L13.1000004,14.555556"
          id="Path"
        ></path>
        <polyline id="Path" strokeLinecap="square" points="3.638889 7.277778 0 3.638889 3.638889 0"></polyline>
      </g>
    </g>
  </svg>
)

ResponseIcon.displayName = 'ResponseIcon'

ResponseIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string
}

ResponseIcon.defaultProps = {
  className: '',
  onClick: () => {},
  title: 'App Builder'
}

export default ResponseIcon
